import { connect } from 'react-redux';

//import { rejectModVersion, removeModVersion } from '../../actions/EditMod';
import { closeDialog } from '../../actions/Dialog';
import { deleteTicket, fastAnswer } from '../../actions/AdminPanel';

import DialogConfirmationTicket 
    from '../../components/Dialogs/DialogConfirmationDeleteTicket/DialogConfirmationTicket';

const mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    isFastAnswer: ownProps.isFastAnswer,
})

const mapDispatchToProps = (dispatch) => ({
    onCloseDialog: () => {
        dispatch(closeDialog())
    },
    // this func for delete ticket with all messages
    onSubmitDialog: (ticketId) => {
        dispatch(deleteTicket(ticketId))
        dispatch(closeDialog())
    },
    // this func for fast answer for this ticket
    onFastAnswer: (ticketId, content, authorId, type) => {
        dispatch(fastAnswer(ticketId, content, authorId))
        dispatch(closeDialog())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(DialogConfirmationTicket)